module.exports = __webpack_public_path__ + "static/media/rentRates-1bedroom-alldwelling-01.ce3841fa.png";